import React from 'react'

import { noOp } from '@/utils/helpers'

import type { PostScope } from '@/client/services/worlds'

import type { OnlineUserBase } from '@/components/Worlds/types'

export type GlobalContextType = {
  onlineUsers: OnlineUserBase[]
}

export const GlobalContext = React.createContext<GlobalContextType>({
  onlineUsers: [],
})

export function useGlobalContext(): GlobalContextType {
  return React.useContext(GlobalContext)
}

export type LayoutContextType = {
  isIndexPage: boolean
  toggleExpandPostId: (postId: number) => void
  expandedPostId: number | null
  toggleShowNotifications: () => void
  showNotifications: boolean
  scope: PostScope
}

export const LayoutContext = React.createContext<LayoutContextType>({
  isIndexPage: false,
  toggleExpandPostId: noOp,
  expandedPostId: null,
  toggleShowNotifications: noOp,
  showNotifications: false,
  scope: 'global',
})

export function useLayoutContext(): LayoutContextType {
  return React.useContext(LayoutContext)
}
